const reopenKey = 'alkhan-reopen-cart';

class AlKhanCartUpsell extends HTMLElement {
  connectedCallback() {
    this.controller?.abort();
    this.controller = new AbortController();

    const signal = this.controller.signal;
    this.index = 0;

    this.addEventListener('click', (event) => {
      if (!(event.target instanceof Element)) return;

      const button = event.target.closest(
        '[data-prev], [data-next], [data-add]'
      );

      if (!button || !this.contains(button)) return;

      event.preventDefault();

      if (button.matches('[data-prev]')) {
        this.move(-1);
      } else if (button.matches('[data-next]')) {
        this.move(1);
      } else if (!button.disabled) {
        this.error = this.querySelector('[data-error]');
        this.add(button);
      }
    }, { signal });

    let startX = null;

    this.addEventListener('touchstart', (event) => {
      if (
        event.target instanceof Element &&
        event.target.closest('[data-viewport]')
      ) {
        startX = event.changedTouches[0].clientX;
      }
    }, { passive: true, signal });

    this.addEventListener('touchend', (event) => {
      if (startX === null) return;

      const distance =
        event.changedTouches[0].clientX - startX;

      startX = null;

      if (Math.abs(distance) > 35) {
        this.move(distance > 0 ? 1 : -1);
      }
    }, { passive: true, signal });
  }

  disconnectedCallback() {
    this.controller?.abort();
  }

  move(step) {
    const slides = [
      ...this.querySelectorAll('[data-slide]')
    ];

    if (slides.length < 2) return;

    const current = slides.findIndex(
      (slide) => !slide.hidden
    );

    this.index = (
      Math.max(current, 0) + step + slides.length
    ) % slides.length;

    slides.forEach((slide, index) => {
      slide.hidden = index !== this.index;
    });
  }
  async add(button) {
    this.error.hidden = true;
    this.querySelectorAll('[data-add]').forEach((item) => {
      item.disabled = true;
    });

    try {
      const root = window.Shopify?.routes?.root || '/';

      const response = await fetch(`${root}cart/add.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({
          items: [{
            id: Number(button.dataset.variant),
            quantity: 1
          }]
        })
      });

      const result = await response.json();

      if (!response.ok) {
        throw new Error(
          result.description ||
          result.message ||
          'تعذر إضافة المنتج. حاول مرة ثانية.'
        );
      }

      try {
        sessionStorage.setItem(reopenKey, '1');
      } catch {
        // The reload still refreshes cart data if storage is blocked.
      }

      window.location.reload();
    } catch (error) {
      this.error.textContent =
        error.message || 'تعذر إضافة المنتج. حاول مرة ثانية.';
      this.error.hidden = false;

      this.querySelectorAll('[data-add]').forEach((item) => {
        item.disabled = false;
      });
    }
  }
}

if (!customElements.get('alkhan-cart-upsell')) {
  customElements.define('alkhan-cart-upsell', AlKhanCartUpsell);
}

async function reopenCart() {
  try {
    if (sessionStorage.getItem(reopenKey) !== '1') return;
    sessionStorage.removeItem(reopenKey);
  } catch {
    return;
  }

  await customElements.whenDefined('theme-drawer');

  requestAnimationFrame(() => {
    const drawer = document.getElementById('cart-drawer');

    if (drawer && typeof drawer.open === 'function') {
      drawer.open();
    }
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', reopenCart, { once: true });
} else {
  reopenCart();
}
